import Button from "./Button";

export default function Input( props ) {

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      let sibling = e.target.nextSibling;
      if (sibling.tagName === 'INPUT') sibling.select();
      else if (sibling.tagName === 'BUTTON') sibling.click();
    }
  }

  return (
    <input
      className="shadow appearance-none border rounded py-2 px-3 text-gray-700 dark:text-gray-300 leading-tight focus:outline-none focus:shadow-outline dark:bg-gray-800"
      id={props.thing}
      type="text"
      placeholder={`Enter a ${props.thing}`}
      value={props.value}
      onChange={props.onChange}
      onKeyDown={handleKeyDown}
      autoComplete="off"
    />
  );

}
  